import { SET_DIGITAL_SECTION_DATA } from "../actions/digitalSectionActions";

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const digitalSectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DIGITAL_SECTION_DATA:
      return { ...state, data: action.payload, status: "success" };
    default:
      return state;
  }
};

export default digitalSectionReducer;
